import React from 'react';
import { ContentContainer } from 'components/styles_components/container';

const Container = ({ children }) => {
  return (
    <ContentContainer maxWidth="xl" sx={{ px: { xs: 0, sm: 2 } }}>
      {children}
    </ContentContainer>
  );
};

export default Container;
